export default {
  generic_error: 'Etwas ist schiefgelaufen',
  address_not_found:
    'Entschuldigung, wir konnten diese Adresse nicht finden. Bitte versuchen Sie es erneut, indem Sie zuerst die Straße im Suchfeld für Adressen eingeben.',
  intern_error:
    'Leider gab es ein unerwartetes Problem mit Ihrer Bestellung, unser Technikteam arbeitet bereits daran 🛠️.',
};
